// TODO: Move to Formatter
export const DATE_FORMAT_SLASH = 'dd/MM/yyyy';

export const SHORT_LOCALIZED = 'PP';

export const READABLE_DATE_FORMAT = 'dd MMMM yyyy';
